<template>
  <v-simple-table class="standard goods-table">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="">
            <div class="header-title">Merce trasportata</div>
            <div class="header-subtitle">Classificazione e aspetto del carico</div>
          </th>
          <th width="100px" class="text-center px-1">
            <div class="header-title">A bordo</div>
            <div class="header-subtitle">dal viaggio prec.</div>
          </th>
          <th width="130px" class="text-body-2 text-center px-1">
            <div class="header-title">
              Caricata
              <InfoTooltip text="Se non hai caricato altra merce della stessa tipologia inserisci il valore 0" />
            </div>
            <div class="header-subtitle">nella loc. di partenza</div>
          </th>
          <th width="130px" class="text-center px-1">
            <div class="header-title">Scaricata</div>
            <div class="header-subtitle">nella loc. di arrivo</div>
          </th>
          <th width="100px" class="text-center px-1">
            <div class="header-title">Rimanente</div>
            <div class="header-subtitle">a bordo</div>
          </th>
          <th width="40px" class=""></th>
        </tr>
      </thead>
      <tbody>
        <slot></slot>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
// Components
import InfoTooltip from '../InfoTooltip.vue'

export default {
  name: 'JourneyFormStandardGoodsTable',
  components: {
    InfoTooltip,
  },
}
</script>

<style lang="scss" scoped>
table > tbody > tr > td {
  padding-top: 0rem !important;
}

.goods-table {
  .header-title {
    font-size: 14px;
    font-weight: 500;
    // letter-spacing: 0.03125em !important;
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: -3px;
  }
  .header-subtitle {
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
